"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bookingServicesActions = require("../actions/bookingServicesActions");

function bookingServicesData() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _bookingServicesActions.BOOKING_SERVICES_DATA_RECEIVED:
            return action.bookingServicesData;
        default:
            return state;
    }
}

exports.default = bookingServicesData;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/bookingServices.js
// module id = 1394
// module chunks = 0